export default "__VITE_ASSET__6ab4e063__"